// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./assets/styles/vars.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100%;
  position: relative;
  font-family: var(--font-family-text);
}

body {
  margin: 0;
}

* {
  box-sizing: border-box;
}

.hover-all {
  transition: all 0.2s ease-in;
}

.hover\\:h-13:hover {
  height: 3.25rem;
}

.hover\\:scale-1:hover {
  transform: scale(1.1);
}

.hover\\:scale-2:hover {
  transform: scale(1.2);
}

.orangeGalcia {
  background-color: rgb(242, 104, 43);
}

.orangeHeaderMenu {
  background-color: rgb(250, 163, 43);
}

.orangePrevencion {
  background-color: rgb(250, 163, 43);
}

.cuadradoNaranja {
  border-width: 0.8rem;
  border-color: rgb(250, 163, 43);
  border-style: solid;
}

.separador {
  border-color: rgb(220, 215, 211);
  background-color: rgb(220, 215, 211);
  height: 0.1rem;
}

.back__img {
  transform: rotate(90deg);
}

button:focus,
a:focus {
  outline: 0;
}

.pl-7 {
  padding-left: 1.75rem;
}

.bg-light-gray {
  background-color: rgb(249, 248, 247);
}

.bg-gray {
  background-color: rgb(240, 236, 235);
}

.bg-dark-gray {
  background-color: rgb(210, 208, 202);
}

.bg-red-transparent {
  background-image: linear-gradient(90deg, rgb(171, 25, 37), rgb(171, 25, 37));
  opacity: 0.95;
}

.bg-red-transparent-soft {
  background-color: rgba( #bd2e1e,0.8%);
}

.bg-lineas {
  background:
    repeating-linear-gradient(
      90deg,
      white 9px,
      white 12px,
      rgb(250, 163, 43) 1px,
      rgb(250, 163, 43) 15px
    );
  height: 10px;
}

.arrowAnticipate {
  transform: rotate(90deg);
}

.text-gray {
  color: rgb(109, 110, 113);
}

.text-dark-gray {
  color:rgb(51, 55, 54);
}

.text-dark-blue {
  color: rgb(39, 34, 62);
}

.late {
  animation-name: pulse;
  animation-duration: 3s !important;
  animation-fill-mode: none !important;
  animation-iteration-count: infinite;
}

.animated.ultraFaster {
  animation-duration: 300ms;
}

.swiper-container {
  height: 100%;
  position: relative;
}

.w-68 {
  width: 18rem;
}

.w-14 {
  width: 3.5rem;
}

.w-15 {
  width: 3.75rem;
}

.w-18 {
  width: 4.5rem;
}

.h-18 {
  height: 4.5rem;
}

.h-40vh {
  min-height: 40vh;
}

.p-1-2 {
  padding: 0.4rem;
}

.pt-6-8 {
  padding-top: 1.7rem;
}

.bounceInUp {
  animation-name: bounceInUp;
}

.bg-lineas-rectas {
  background:
    repeating-linear-gradient(
      90deg,
      rgba(0, 0, 0, 0) 10px,
      rgba(0, 0, 0, 0) 14px,
      rgb(242, 104, 43) 1px,
      rgb(242, 104, 43) 15px
    );
  z-index: 10;
  top: -0.5rem;
}

.bottom-1 {
  bottom: -0.5rem;
}

.bottom-2 {
  bottom: -1.5rem;
}

.spin {
  animation: spin 0.2s ease-in-out;
}

.spinClose {
  animation: spinClose 0.2s ease-in-out;
}

.open {
  animation: collapseDown 2s linear;
}

.close {
  animation: collapseUp 0.2s linear;
}

.position-top-1 {
  object-position: 0 15%;
}

.z-n-10 {
  z-index: -10;
}

@keyframes spin {
  from {
    transform: rotate(90deg);
  }

  to {
    transform: rotate(0deg);
  }
}

@keyframes spinClose {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(90deg);
  }
}

@keyframes collapseDown {
  from {
    transform: translate3d(0, -100px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

@keyframes collapseUp {
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0);
  }

  75% {
    transform: translate3d(0, 10px, 0);
  }

  90% {
    transform: translate3d(0, -5px, 0);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}

button:focus {
  outline: 0;
}

.app-container{
  overflow: hidden;
}

li{
  list-style-type: none;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;;EAEE,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAIE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4EAA4E;EAC5E,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;;;;;;;KAOG;EACH,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,oCAAoC;EACpC,mCAAmC;AACrC;;AAEA;EAEE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,0BAA0B;AAC5B;;AAEA;EACE;;;;;;;KAOG;EACH,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IAEE,oCAAoC;EACtC;;EAEA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE;;;;;IAME,8DAA8D;EAChE;;EAEA;IACE,UAAU;IAEV,oCAAoC;EACtC;;EAEA;IACE,UAAU;IAEV,mCAAmC;EACrC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,kCAAkC;EACpC;;EAEA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["@import url(\"./assets/styles/vars.css\");\r\n\r\nhtml,\r\nbody {\r\n  height: 100%;\r\n  position: relative;\r\n  font-family: var(--font-family-text);\r\n}\r\n\r\nbody {\r\n  margin: 0;\r\n}\r\n\r\n* {\r\n  box-sizing: border-box;\r\n}\r\n\r\n.hover-all {\r\n  -moz-transition: all 0.2s ease-in;\r\n  -o-transition: all 0.2s ease-in;\r\n  -webkit-transition: all 0.2s ease-in;\r\n  transition: all 0.2s ease-in;\r\n}\r\n\r\n.hover\\:h-13:hover {\r\n  height: 3.25rem;\r\n}\r\n\r\n.hover\\:scale-1:hover {\r\n  -webkit-transform: scale(1.1);\r\n  transform: scale(1.1);\r\n}\r\n\r\n.hover\\:scale-2:hover {\r\n  -webkit-transform: scale(1.2);\r\n  transform: scale(1.2);\r\n}\r\n\r\n.orangeGalcia {\r\n  background-color: rgb(242, 104, 43);\r\n}\r\n\r\n.orangeHeaderMenu {\r\n  background-color: rgb(250, 163, 43);\r\n}\r\n\r\n.orangePrevencion {\r\n  background-color: rgb(250, 163, 43);\r\n}\r\n\r\n.cuadradoNaranja {\r\n  border-width: 0.8rem;\r\n  border-color: rgb(250, 163, 43);\r\n  border-style: solid;\r\n}\r\n\r\n.separador {\r\n  border-color: rgb(220, 215, 211);\r\n  background-color: rgb(220, 215, 211);\r\n  height: 0.1rem;\r\n}\r\n\r\n.back__img {\r\n  transform: rotate(90deg);\r\n}\r\n\r\nbutton:focus,\r\na:focus {\r\n  outline: 0;\r\n}\r\n\r\n.pl-7 {\r\n  padding-left: 1.75rem;\r\n}\r\n\r\n.bg-light-gray {\r\n  background-color: rgb(249, 248, 247);\r\n}\r\n\r\n.bg-gray {\r\n  background-color: rgb(240, 236, 235);\r\n}\r\n\r\n.bg-dark-gray {\r\n  background-color: rgb(210, 208, 202);\r\n}\r\n\r\n.bg-red-transparent {\r\n  background-image: linear-gradient(90deg, rgb(171, 25, 37), rgb(171, 25, 37));\r\n  opacity: 0.95;\r\n}\r\n\r\n.bg-red-transparent-soft {\r\n  background-color: rgba( #bd2e1e,0.8%);\r\n}\r\n\r\n.bg-lineas {\r\n  background:\r\n    repeating-linear-gradient(\r\n      90deg,\r\n      white 9px,\r\n      white 12px,\r\n      rgb(250, 163, 43) 1px,\r\n      rgb(250, 163, 43) 15px\r\n    );\r\n  height: 10px;\r\n}\r\n\r\n.arrowAnticipate {\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.text-gray {\r\n  color: rgb(109, 110, 113);\r\n}\r\n\r\n.text-dark-gray {\r\n  color:rgb(51, 55, 54);\r\n}\r\n\r\n.text-dark-blue {\r\n  color: rgb(39, 34, 62);\r\n}\r\n\r\n.late {\r\n  animation-name: pulse;\r\n  animation-duration: 3s !important;\r\n  animation-fill-mode: none !important;\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n.animated.ultraFaster {\r\n  -webkit-animation-duration: 300ms;\r\n  animation-duration: 300ms;\r\n}\r\n\r\n.swiper-container {\r\n  height: 100%;\r\n  position: relative;\r\n}\r\n\r\n.w-68 {\r\n  width: 18rem;\r\n}\r\n\r\n.w-14 {\r\n  width: 3.5rem;\r\n}\r\n\r\n.w-15 {\r\n  width: 3.75rem;\r\n}\r\n\r\n.w-18 {\r\n  width: 4.5rem;\r\n}\r\n\r\n.h-18 {\r\n  height: 4.5rem;\r\n}\r\n\r\n.h-40vh {\r\n  min-height: 40vh;\r\n}\r\n\r\n.p-1-2 {\r\n  padding: 0.4rem;\r\n}\r\n\r\n.pt-6-8 {\r\n  padding-top: 1.7rem;\r\n}\r\n\r\n.bounceInUp {\r\n  -webkit-animation-name: bounceinup;\r\n  animation-name: bounceInUp;\r\n}\r\n\r\n.bg-lineas-rectas {\r\n  background:\r\n    repeating-linear-gradient(\r\n      90deg,\r\n      rgba(0, 0, 0, 0) 10px,\r\n      rgba(0, 0, 0, 0) 14px,\r\n      rgb(242, 104, 43) 1px,\r\n      rgb(242, 104, 43) 15px\r\n    );\r\n  z-index: 10;\r\n  top: -0.5rem;\r\n}\r\n\r\n.bottom-1 {\r\n  bottom: -0.5rem;\r\n}\r\n\r\n.bottom-2 {\r\n  bottom: -1.5rem;\r\n}\r\n\r\n.spin {\r\n  animation: spin 0.2s ease-in-out;\r\n}\r\n\r\n.spinClose {\r\n  animation: spinClose 0.2s ease-in-out;\r\n}\r\n\r\n.open {\r\n  animation: collapseDown 2s linear;\r\n}\r\n\r\n.close {\r\n  animation: collapseUp 0.2s linear;\r\n}\r\n\r\n.position-top-1 {\r\n  object-position: 0 15%;\r\n}\r\n\r\n.z-n-10 {\r\n  z-index: -10;\r\n}\r\n\r\n@keyframes spin {\r\n  from {\r\n    transform: rotate(90deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(0deg);\r\n  }\r\n}\r\n\r\n@keyframes spinClose {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(90deg);\r\n  }\r\n}\r\n\r\n@keyframes collapseDown {\r\n  from {\r\n    -webkit-transform: translate3d(0, 100px, 0);\r\n    transform: translate3d(0, -100px, 0);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n\r\n@keyframes collapseUp {\r\n  from,\r\n  60%,\r\n  75%,\r\n  90%,\r\n  to {\r\n    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\r\n  }\r\n\r\n  from {\r\n    opacity: 0;\r\n    -webkit-transform: translate3d(0, 3000px, 0);\r\n    transform: translate3d(0, 3000px, 0);\r\n  }\r\n\r\n  60% {\r\n    opacity: 1;\r\n    -webkit-transform: translate3d(0, -20px, 0);\r\n    transform: translate3d(0, -20px, 0);\r\n  }\r\n\r\n  75% {\r\n    -webkit-transform: translate3d(0, 10px, 0);\r\n    transform: translate3d(0, 10px, 0);\r\n  }\r\n\r\n  90% {\r\n    -webkit-transform: translate3d(0, -5px, 0);\r\n    transform: translate3d(0, -5px, 0);\r\n  }\r\n\r\n  to {\r\n    -webkit-transform: translate3d(0, 0, 0);\r\n    transform: translate3d(0, 0, 0);\r\n  }\r\n}\r\n\r\nbutton:focus {\r\n  outline: 0;\r\n}\r\n\r\n.app-container{\r\n  overflow: hidden;\r\n}\r\n\r\nli{\r\n  list-style-type: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
